import * as React from "react";
import type { SVGProps } from "react";
const SvgCloudLock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#26A3DD"
      d="M16.21 15.776h-.584C6.996 15.776 0 22.691 0 31.283 0 39.846 6.968 46.79 15.626 46.79h19.148v-1.697H15.626c-7.731 0-13.929-6.194-13.929-13.81 0-7.64 6.223-13.81 13.93-13.81h1.972l.274-1.361C19.143 9.813 24.744 5.09 31.486 5.09c6.743 0 12.345 4.725 13.613 10.993l.276 1.36h1.97c7.726 0 13.933 6.19 13.988 13.845 0 2.02-.436 3.936-1.219 5.663l1.22 1.378a15.372 15.372 0 0 0 1.696-7.047c-.058-8.592-7.026-15.536-15.684-15.536h-.583C45.334 8.688 39.037 3.394 31.486 3.394c-7.55 0-13.848 5.294-15.277 12.382Z"
    />
    <path
      fill="#D3ECF8"
      d="M64 45.576c0 8.3-6.73 15.03-15.03 15.03-8.301 0-15.03-6.73-15.03-15.03 0-8.301 6.729-15.03 15.03-15.03 8.3 0 15.03 6.729 15.03 15.03Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M45.816 39.393a.115.115 0 0 0-.116.115v4.334a.545.545 0 1 1-1.09 0v-4.334c0-.665.54-1.205 1.206-1.205h5.339c.665 0 1.205.54 1.205 1.205v4.334a.545.545 0 1 1-1.09 0v-4.334a.115.115 0 0 0-.115-.115h-5.34Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M41.697 44.712c0-.666.54-1.205 1.205-1.205h11.166c.665 0 1.205.54 1.205 1.205v7.004c0 .665-.54 1.204-1.205 1.204H42.902c-.666 0-1.205-.539-1.205-1.204v-7.004Zm1.205-.116a.115.115 0 0 0-.116.116v7.004c0 .063.052.115.116.115h11.166a.115.115 0 0 0 .115-.115v-7.004a.115.115 0 0 0-.115-.116H42.902Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M49.42 49.19a1.83 1.83 0 0 0-.935-3.403 1.83 1.83 0 0 0-.934 3.405l-.21.523a.695.695 0 0 0 .646.953h.998a.695.695 0 0 0 .645-.953l-.21-.524Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M48.97 58.909c7.364 0 13.333-5.97 13.333-13.333 0-7.364-5.97-13.334-13.333-13.334-7.364 0-13.334 5.97-13.334 13.334s5.97 13.333 13.334 13.333Zm0 1.697c8.3 0 15.03-6.73 15.03-15.03 0-8.301-6.73-15.03-15.03-15.03-8.301 0-15.03 6.729-15.03 15.03 0 8.3 6.729 15.03 15.03 15.03Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCloudLock;
